import { PAGE_URL } from "../../../utils";

export const EVIDENCE_VIEWER_URL = `${PAGE_URL.EVIDENCE_VIEWER}?type=All&gender=Both&ageGroup=All&location=All+Countries&interventions=All&multipleFiles=true`;
